import MyAccountSideMenuContainer from './MyAccountSideMenuContainer';

export default MyAccountSideMenuContainer;
